module.exports = __webpack_public_path__ + "static/media/farm-dcnfqXisV4.6cbdcfbb.png";